import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useProAuth } from "./ProAuthContext";

export default function ProProtectedRoute({ children }) {
  const { user, loading } = useProAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[var(--mc-navy-950)] grid place-items-center">
        <div className="text-[var(--mc-muted)] text-sm">Chargement de votre espace…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/mssante/connexion" replace state={{ from: location.pathname }} />;
  }

  return children;
}
